import React from "react";
import ReactSimpleRange from "react-simple-range";

import { getCarSetting, updateCar } from "../../model/car";
import { getLoggedProfile } from "../../model/profile";

import { commonErr } from "../common/errors";
import { formatPrice } from "../common/common";
import { MessageBox, MessageLine } from "../common/messagebox";
import { LoadingInline, LoadingOverlay } from "../common/loading";

export class CarSettingDeliveryWD extends React.Component {
	constructor() {
		super();
		this.state = {
			err: commonErr.INNIT,
			errMsg: "",
			updateErrMsg: "",
		};
	}

	init(car) {
		getCarSetting({ carId: car.id }).then((carSettingResp) => {
			const setting = carSettingResp.data.data.wdSetting;
			if (setting) {
				this.setState({
					err: carSettingResp.data.error,
					errMsg: carSettingResp.data.errorMessage,

					// isDelivery: car.wdShort.deliveryEnable === 1,
					isDelivery: true,
					deliveryRadius: car.wdShort.deliveryRadius,
					deliveryPrice: car.wdShort.deliveryPrice,
					deliveryRadiusFree: car.wdShort.deliveryRadiusFree,

					car,
					setting,
				});
			} else {
				this.setState({
					err: carSettingResp.data.error,
					errMsg: carSettingResp.data.errorMessage,
				});
			}
		});
	}

	componentDidMount() {
		const car = this.props.car;
		this.init(car);
	}

	componentWillReceiveProps(props) {
		const car = props.car;
		this.init(car);
	}

	// toggleDelivery() {
	// 	this.setState({
	// 		isDelivery: !this.state.isDelivery
	// 	});
	// }

	onDeliveryRadiusChange(range) {
		this.setState({
			deliveryRadius: range.value,
		});
	}

	onDeliveryPriceChange(range) {
		this.setState({
			deliveryPrice: range.value,
		});
	}

	onDeliveryRadiusFreeChange(range) {
		this.setState({
			deliveryRadiusFree: range.value,
		});
	}

	hideMessageBox() {
		this.setState({
			updateErrMsg: "",
		});
	}

	updateCarInfo() {
		const { isDelivery, deliveryRadius, deliveryPrice, deliveryRadiusFree } = this.state;

		this.setState({
			err: commonErr.LOADING,
		});
		updateCar(this.state.car.id, {
			wdDeliveryEnable: isDelivery,
			wdDeliveryRadius: deliveryRadius,
			wdDeliveryPrice: deliveryPrice,
			wdDeliveryRadiusFree: deliveryRadiusFree,

			// set withDriver:true for update value of with driver
			// not set for self drive,
			withDriver: true,
		}).then((updateCarResp) => {
			this.setState({
				err: updateCarResp.data.error,
				updateErrMsg: updateCarResp.data.errorMessage,
			});
		});
	}

	render() {
		var content;
		const { err, updateErrMsg, isDelivery, deliveryPrice, deliveryRadius, deliveryRadiusFree, car, setting } =
			this.state;
		if (err === commonErr.INNIT) {
			content = <LoadingInline />;
		} else if (!car || !setting) {
			content = <MessageLine message="Không tìm thấy thông tin." />;
		} else {
			content = (
				<div className="content">
					{err === commonErr.LOADING && <LoadingOverlay />}
					{updateErrMsg && updateErrMsg !== "" && (
						<MessageBox
							error={err}
							message={updateErrMsg}
							show={updateErrMsg && updateErrMsg !== ""}
							hideModal={this.hideMessageBox.bind(this)}
						/>
					)}
					<div className="content-container">
						<div className="form-default">
							{/* <h3 className="title">Đưa đón tận nơi</h3>
						<p className="position-relative pos-1">
							<div className="switch-on-off" style={{ right: "0", position: "absolute", bottom: "10px" }}>
								<input className="switch-input" id="cb-instant-delivery" type="checkbox" checked={isDelivery} onClick={this.toggleDelivery.bind(this)} />
								<label className="switch-label" for="cb-instant-delivery"></label>
							</div>
						</p> */}
							{isDelivery && (
								<div>
									<div className="col-1">
										<div className="line-form end">
											<label className="label">Đưa đón trong vòng</label>
											<div className="range-slider">
												<ReactSimpleRange
													step={5}
													min={setting.deliveryRadiusMin}
													max={setting.deliveryRadiusMax}
													value={deliveryRadius}
													sliderSize={14}
													thumbSize={16}
													label={false}
													trackColor={"#00a550"}
													thumbColor={"#141414"}
													onChange={this.onDeliveryRadiusChange.bind(this)}
												/>
											</div>
											<span style={{ float: "right", fontSize: "14px" }}>{`${deliveryRadius}km`}</span>
											<div className="space m" />
											<p className="pl">
												<span className="note">Quãng đường đề xuất: {`${setting.deliveryRadiusRecommend}km`}</span>
											</p>
										</div>
									</div>

									<div className="col-2">
										<div className="line-form end">
											<label className="label">Phí đưa đón cho mỗi km</label>
											<div className="range-slider">
												<ReactSimpleRange
													step={1000}
													min={setting.deliveryPriceMin}
													max={setting.deliveryPriceMax}
													value={deliveryPrice}
													sliderSize={14}
													thumbSize={16}
													label={false}
													trackColor={"#00a550"}
													thumbColor={"#141414"}
													onChange={this.onDeliveryPriceChange.bind(this)}
												/>
											</div>
											<span style={{ float: "right", fontSize: "14px" }}>{`${
												deliveryPrice > 0 ? `${formatPrice(deliveryPrice)}` : "Miễn phí"
											}`}</span>
											<div className="space m" />
											<p className="pl">
												<span className="note">Phí đề xuất: {formatPrice(setting.deliveryPriceRecommend)}</span>
											</p>
										</div>
									</div>
									<div className="col-1">
										<div className="line-form end">
											<label className="label">Miễn phí đưa đón trong vòng</label>
											<div className="range-slider">
												<ReactSimpleRange
													step={5}
													min={setting.deliveryRadiusFreeMin}
													max={setting.deliveryRadiusFreeMax}
													value={deliveryRadiusFree}
													sliderSize={14}
													thumbSize={16}
													label={false}
													trackColor={"#00a550"}
													thumbColor={"#141414"}
													onChange={this.onDeliveryRadiusFreeChange.bind(this)}
												/>
											</div>
											<span style={{ float: "right", fontSize: "14px" }}>{`${deliveryRadiusFree}km`}</span>
											<div className="space m" />
											<p className="pl">
												<span className="note">Quãng đường đề xuất: {`${setting.deliveryRadiusFreeRecommend}km`}</span>
											</p>
										</div>
									</div>

									<div className="space m clear" />
								</div>
							)}
						</div>
						<div className="line"></div>
						<a className="btn btn-primary btn--m" onClick={this.updateCarInfo.bind(this)}>
							Lưu thay đổi
						</a>
					</div>
				</div>
			);
		}
		return content;
	}
}

export class CarSettingPoliciesWD extends React.Component {
	constructor() {
		super();
		this.state = {
			err: commonErr.INNIT,
			errMsg: "",
			updateErrMsg: "",
		};
	}

	init(car) {
		getCarSetting({ carId: car.id }).then((carSettingResp) => {
			const wdSetting = carSettingResp.data.data.wdSetting;
			if (wdSetting) {
				this.setState({
					err: carSettingResp.data.error,
					errMsg: carSettingResp.data.errorMessage,

					policies: wdSetting.policiesSpecific === 1 ? wdSetting.policies : car.wdFull.policies,
					isPoliciesSpecific: wdSetting.policiesSpecific === 1,

					car,
					setting: wdSetting,
				});
			} else {
				this.setState({
					err: carSettingResp.data.error,
					errMsg: carSettingResp.data.errorMessage,
				});
			}
		});
	}

	componentDidMount() {
		const car = this.props.car;
		this.init(car);
	}

	componentWillReceiveProps(props) {
		const car = props.car;
		this.init(car);
	}

	onPolicyChange(event) {
		this.setState({
			policies: event.target.value,
		});
	}

	hideMessageBox() {
		this.setState({
			updateErrMsg: "",
		});
	}

	updateCarInfo() {
		const policies = this.state.policies;

		this.setState({
			err: commonErr.LOADING,
		});
		updateCar(this.state.car.id, {
			wdPolicies: encodeURI(policies),

			withDriver: true, //set to update data in mode with driver
		}).then((updateCarResp) => {
			this.setState({
				err: updateCarResp.data.error,
				updateErrMsg: updateCarResp.data.errorMessage,
				isPoliciesSpecific: this.state.isPoliciesSpecific,
			});
		});
	}

	render() {
		var content;
		if (this.state.err === commonErr.INNIT) {
			content = <LoadingInline />;
		} else if (!this.state.car || !this.state.setting) {
			content = <MessageLine message="Không tìm thấy thông tin." />;
		} else {
			content = (
				<div className="content">
					{this.state.err === commonErr.LOADING && <LoadingOverlay />}
					{this.state.updateErrMsg && this.state.updateErrMsg !== "" && (
						<MessageBox
							error={this.state.err}
							message={this.state.updateErrMsg}
							show={this.state.updateErrMsg && this.state.updateErrMsg !== ""}
							hideModal={this.hideMessageBox.bind(this)}
						/>
					)}
					<div className="content-container">
						<h3 className="title">Điều khoản thuê xe</h3>

						<span className="note marginBottom-s">Thiết lập các yêu cầu khi thuê xe {this.state.car.name}.</span>

						{/* {!this.state.isPoliciesSpecific && <span className="note">Lưu ý: Xe đang áp dụng thiết lập điều khoản chung. Tắt thiết lập chung nếu muốn tuỳ chỉnh riêng cho xe này</span>} */}
						{/* <div className="position-relative pos-1 d-flex" style={{ justifyContent: "space-between" }}>
						<p style={{ marginBottom: 0 }}>Sử dụng thiết lập chung</p>
						<div className="switch-on-off">
							<input className="switch-input" id="cb-policies-spec" type="checkbox" checked={!this.state.isPoliciesSpecific} onClick={this.togglePoliciesSpecific.bind(this)} />
							<label className="switch-label" for="cb-policies-spec"></label>
						</div>
					</div> */}
						<div className="space m"></div>
						<div className="form-default">
							<div className="line-form end custom-textarea">
								<textarea
									className="textarea"
									// disabled={!this.state.isPoliciesSpecific}
									onChange={this.onPolicyChange.bind(this)}
									value={this.state.policies ? this.state.policies : ""}
									placeholder={`1. Không hút thuốc trên xe hoặc mang các thực phẩm có mùi 2. Để đảm bảo thời gian đón khách đúng giờ & tránh tắc đường, tài xế chỉ đón khách tại điểm đã đặt xe hoặc điểm thay thế (Vui lòng báo trước cho tài xế trong trường hợp có thay đổi địa điểm đón khách) 3. Trong trường hợp khách thuê thay đổi lộ trình chuyến đi, vui lòng báo trước với tài xế để chuẩn bị và chăm sóc tốt hơn. Chúc Quý Khách chuyến đi vui vẻ`}></textarea>

								{/* <p><span className="note">Ghi rõ các yêu cầu thuê xe.</span></p> */}
							</div>
						</div>
						<div className="space m"></div>
						<div className="line"></div>

						<a className="btn btn-primary btn--m" onClick={this.updateCarInfo.bind(this)}>
							Lưu thay đổi
						</a>
					</div>
				</div>
			);
		}

		return content;
	}
}
